'use client'

import { useEffect } from 'react'
import { useIsMobile } from '@cocoonspace/ui/hooks/use-mobile'
import { usePathname } from 'next/navigation'

import { ZONE_SEARCH_PATHS } from '~/config/zones'
import { stripLocaleFromPath } from '~/i18n/routing'

const KNOWN_TOP_LEVEL_ROUTES = new Set([
	'',
	'account',
	'auth',
	'blog',
	'booking',
	'bureau-a-l-heure',
	'dashboard',
	'events',
	'favorites',
	'london',
	'lyon',
	'mentions-legales',
	'offers',
	'on-site-qr',
	'overstays',
	'paris',
	'payment',
	'politique-confidentialite',
	'quotations',
	'reglement-cocoon',
	'salle-de-reunion',
	'scheduling',
	'unsubscribe',
	'use-cases',
	'venues',
])

const isUserPublicPage = (pathname: string) => {
	const segments = pathname.split('/').filter(Boolean)

	if (segments.length === 1) {
		return !KNOWN_TOP_LEVEL_ROUTES.has(segments[0])
	}

	if (segments.length === 2) {
		return !KNOWN_TOP_LEVEL_ROUTES.has(segments[0])
	}

	return false
}

export const useHideFrontChat = () => {
	const isMobile = useIsMobile()
	const pathname = stripLocaleFromPath(usePathname() ?? '')
	const path = pathname.split('?')[0]

	useEffect(() => {
		if (typeof window === 'undefined') return

		// /paris, /lyon, etc.
		const isSearchPage = ZONE_SEARCH_PATHS.some((zonePath) => path === zonePath)

		// /paris/123, /lyon/456, etc.
		const isSpaceDetailsPage = ZONE_SEARCH_PATHS.some((zonePath) =>
			path.startsWith(`${zonePath}/`),
		)

		// /bureau-a-l-heure/paris, /salle-de-reunion/lyon, etc.
		const isLandingPages =
			path.startsWith('/bureau-a-l-heure') ||
			path.startsWith('/salle-de-reunion')

		const shouldHideFrontChat =
			isUserPublicPage(path) ||
			isSearchPage ||
			isLandingPages ||
			(isMobile && isSpaceDetailsPage)

		if (shouldHideFrontChat) {
			document.body.classList.add('[&_#front-chat-iframe]:hidden')
		} else {
			document.body.classList.remove('[&_#front-chat-iframe]:hidden')
		}
	}, [path, isMobile])
}
